// Helper that resolves a service CTA to its actual destination.
// Returns { href, target, isInternal, label, state? } for the consumer to render.
//
// SEO-critical: internal contact CTAs never emit ?service= or ?intent= in the
// href. The preselected service/intent is passed via React Router link state,
// which does not change the crawlable URL. Contact.jsx reads that state and
// prefills the form. Old bookmarked ?service= URLs still resolve for humans.
import { SITE } from "@/data/config";
import { resolvePricing } from "@/lib/pricing";

const CONTACT = "/contact";

export const resolveServiceCta = (service) => {
  const slug = service?.slug;
  const cta = service?.cta || { kind: "contact", label: "Contact" };
  const kind = cta.kind;
  const pricing = resolvePricing(service);

  // Proposal-based services always route to /contact with intent=quote,
  // via link state. Label is forced to "Request Scope".
  if (pricing.ctaHrefOverride) {
    return {
      href: pricing.ctaHrefOverride,
      target: undefined,
      isInternal: true,
      label: pricing.ctaLabelOverride,
      state: pricing.ctaStateOverride,
    };
  }

  if (kind === "book") {
    return { href: SITE.bookingUrl, target: "_blank", isInternal: false, label: cta.label };
  }
  if (kind === "shop") {
    return { href: SITE.shopUrl, target: "_blank", isInternal: false, label: cta.label };
  }
  if (kind === "stripe") {
    const link = (service.stripePaymentLink || "").trim();
    if (link) return { href: link, target: "_blank", isInternal: false, label: cta.label };
    return {
      href: CONTACT,
      target: undefined,
      isInternal: true,
      label: cta.label,
      state: { serviceSlug: slug, intent: null },
    };
  }
  if (kind === "quote") {
    return {
      href: CONTACT,
      target: undefined,
      isInternal: true,
      label: cta.label,
      state: { serviceSlug: slug, intent: "quote" },
    };
  }
  // default: contact
  return {
    href: CONTACT,
    target: undefined,
    isInternal: true,
    label: cta.label,
    state: { serviceSlug: slug, intent: null },
  };
};
